core.constant('biTranslationPL', {
  "T": {
    "MODULE": {
      "BI" : {
        "RAPORTS": "Raporty"
      }
    },
    "SAIKU_NAME": {
      "Patients_by_age.saiku": "Liczba pacjentów wg wieku",
      "Patients_by_allergy_city.saiku": "Liczba pacjentów wg uczuleń i miast",
      "Patients_by_Alergy_Age_Drug.saiku": "Liczba pacjentów wg uczuleń, wieku i przyjmowanych leków",
      "Patients_by_Alergy_Drug.saiku": "Liczba Pacjentów wg uczuleń i przyjmowanych leków",
      "Patients_by_voivodenship.saiku": "Liczba pacjentów wg województw",
      "Patients_by_voivodenship_allergy.saiku":  "Liczba pacjentów wg województw i uczuleń",
      "Patients_by_voivodenship_drugs.saiku": "Liczba pacjentów wg województw i przyjmowanych leków",
      "Patients_by_alergy_sex.saiku": "Liczba pacjentów wg uczuleń i płci",
      "Patients_by_city.saiku": "Liczba pacjentów wg miast",
      "Patients_by_city_drug.saiku": "Liczba pacjentów wg miast i przyjmowanych leków",
      "Patients_by_Country_Allergy.saiku": "Liczba pacjentów wg państw i uczuleń",
      "Patients_by_Country_Drugs.saiku": "Liczba pacjentów wg państw i przyjmowanych leków",
      "Patients_by_drugs.saiku": "Liczba pacjentów wg przyjmowanych leków",
      "Patients_by_Sex_Drugs.saiku": "Liczba pacjentów wg płci i przyjmowanych leków",
      "Visits by ICD10.saiku": "Liczba wizyt wg ICD10",
      "Visits_by_Country.saiku": "Liczba wizyt wg państw",
      "Visits_by_ICD9.saiku": "Liczba wizyt wg ICD9",
      "Visits_by_ICD10.saiku": "Liczba wizyt wg ICD10",
      "Visits_by_voivodeship_ICD10.saiku": "Liczba wizyt wg ICD10",
      "Visits_by_voivodeship_ICD9.saiku": "Liczba wizyt wg ICD10",
      "Visits_by_voivodeship_ICF.saiku": "Liczba wizyt wg ICF",
      "Visits_by_ICD9_Country.saiku": "Liczba wizyt wg ICD9 i państw",
      "Visits_by_ICD10_Country.saiku": "Liczba wizyt wg ICD10 i państw",
      "Visits_by_ICF_Country.saiku": "Liczba wizyt wg ICF i państw",
      "Visits_by_ICD9_ICD10.saiku": "Liczba wizyt wg ICD9 i ICD10",
      "Visits_by_Month_ICD10.saiku": "Liczba wizyt wg miesiąca i ICD10",
      "Visits_by_Month_ICD9.saiku": "Liczba wizyt wg miesiąca i ICD9",
      "Visits_by_voivodenship.saiku": "Liczba wizyt wg województw",
      "Visits_by_Year_City.saiku": "Liczba wizyt wg roku i miast",
      "Visits_by_ICD9_ICF.saiku": "Liczba wizyt wg ICD9 i ICF"
    }
  }
});

